<template>
  <div>

    <b-card no-body class="card-statistics">
      <b-card-body class="statistics-body">
        <div class="d-flex align-items-center justify-content-center border">
          <div class="d-flex flex-column mx-1 p-1">
            <div class="d-flex flex-row justify-content-center">
              <div class="flex-column my-2">
                <p>{{ $t('Containers') }}</p>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-center my-1">
              <div class="flex-column mb-2">
                <vue-apex-charts :options="getChartOptions()" :series="[data.Dumped, data.NotDumped]" :height="200" />
              </div>
            </div>
            <div>
            </div>
            <div class="d-flex flex-row justify-content-center">
              <div v-for="item in [
                {
                  count: data.Total,
                  label: 'Total',
                  onListClick: () => showContainers({ title: 'Containers' }),
                  color: '#D6D5D5'
                },
                {
                  count: data.Dumped,
                  label: 'Dumped',
                  onListClick: () => showDevices(),
                  color: '#04d600'
                },
                {
                  count: data.NotDumped,
                  label: 'Not Dumped',
                  onListClick: () => showContainers({ title: 'Not Dumped', isDumped: false }),
                  color: '#d61002'
                }
              ]" class="d-flex flex-column mx-1 p-1">
                <div class="d-flex flex-row justify-content-center">
                  <div class="flex-column" :style="`width: 10px;height: 30px;background-color: ${item.color};`">
                  </div>
                  <div class="flex-column" style="margin-inline: 8px;">
                    <h3>{{ item.count }}</h3>
                  </div>
                </div>
                <div class="flex-row">
                  <p class="fs-1">{{ $t(item.label) }}</p>
                </div>
                <div class="flex-row">
                  <b-button variant="primary" @click="item.onListClick" class="w-100"><feather-icon size="10"
                      icon="ListIcon" /></b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <ListModal ref="devicesListModal" />
    <ListModal ref="containersListModal" />

  </div>
</template>

<script>
import {
  BFormGroup, BCard, BCardHeader,
  BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside,
  BAvatar, BMediaBody, BLink, BContainer, BTable, BPagination, BFormSelect, BButton, VBTooltip
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
import ListModal from './modals/ListModal.vue'
import axios from '@/libs/axios'
import store from '@/store'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    OrbitSpinner,
    VueApexCharts,
    ListModal
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {
    data: {
      type: Object,
      default: () => { },
    }
  },

  setup(props, { root }) {

    const devicesListModal = ref(null)

    const containersListModal = ref(null)

    const showContainers = (config) => {
      containersListModal.value.showModal({
        title: root.$t(config.title),
        list: new Promise((resolve, reject) => {

          let params = {
            type: 'containerStatus',
            needPagination: false
          }

          if (config.hasOwnProperty('isDumped')) {
            params.isDumped = config.isDumped
          }

          if (config.hasOwnProperty('devices')) {
            params.devices = config.devices
          }

          axios.post(`reports`, params)
          .then(res => {
            resolve(Object.values(res.data.data))
          })
          .catch(reason => reject(reason.response))

        }),
        fields: [{ key: 'contract', label: 'contract' }, { key: 'type', label: 'Container Type' }, { key: 'code', label: 'code' }, { key: 'tag', label: 'tag' }]
      })
    }


    const showDevices = () => {
      devicesListModal.value.showModal({
        title: root.$t('Dumped'),
        list: new Promise((resolve, reject) => {
          axios.post(`reports`, {
            type: 'deviceCurrentDump',
            needPagination: false
          })
          .then(res => {
            resolve(Object.values(res.data.data))
          })
          .catch(reason => reject(reason.response))
        }),
        fields: [{ key: 'contract', label: 'contract' }, { key: 'name', label: 'device' }, { key: 'dumped', label: 'containers' }],
        onRowClick: (e) => {
          if (e.field.key == 'dumped'){
            showContainers({title: `${root.$t('Containers Dumped By')} ${e.item.name}`, devices:[e.item.device_id]})
          }
        }
      })
    }

    const getChartOptions = () => {
      return {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 5,
            opacity: 0.2
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px',
            fontWeight: 'bold'
          }
        },
        legend: { show: false, position: 'top' },
        labels: [root.$t('Dumped'), root.$t('Not Dumped')],
        stroke: {},
        colors: ['#04d600', '#d61002'],
        grid: {
          padding: {
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: ''
                },
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0.2
          }
        }
      }
    }





    return {
      getChartOptions,
      devicesListModal,
      containersListModal,
      showContainers,
      showDevices
    }

  }
}
</script>
